import { useCallback } from 'react';

import { MODAL_NAMES } from 'common/activeElements/modals/modalNames';
import { SIDEBAR_NAMES } from 'common/activeElements/sidebars/sidebarsNames';
import { useActiveElements } from 'global/ActiveElements/useActiveElements';

import { ACTIVITY_RENDER_TYPES } from './const';

export function useChipModalOpener() {
	const active = useActiveElements();

	const open = useCallback(
		(renderType, payload = {}, opts = {}) => {
			const { fromTimestamp = null, toTimestamp = null } = payload;
			const timestamps = { fromTimestamp, toTimestamp };

			switch (renderType) {
				case ACTIVITY_RENDER_TYPES.absence: {
					const readOnly = Object.hasOwn(opts, 'readOnly') ? Boolean(opts.readOnly) : true;
					const reason =
						typeof payload.reason === 'object'
							? (payload.reason?.id ?? null)
							: (payload.reason ?? null);

					const initialData = {
						...timestamps,
						reason,
						note: payload.note ?? '',
					};

					active.setActiveElement(MODAL_NAMES.absence, {
						readOnly,
						initialData,
					});
					return;
				}

				case ACTIVITY_RENDER_TYPES.protection:
					active.setActiveElement(MODAL_NAMES.protection, {
						readOnly: true,
						initialData: { ...payload },
					});
					return;

				case ACTIVITY_RENDER_TYPES.traveling:
					active.setActiveElement(MODAL_NAMES.traveling, {
						readOnly: true,
						initialData: { ...payload },
					});
					return;
				case ACTIVITY_RENDER_TYPES.idle:
				case ACTIVITY_RENDER_TYPES.rest:
					return;
				default: {
					active.setActiveElement(SIDEBAR_NAMES.waDetails, {
						crewMemberId: payload.crewMemberId,
						sequenceGroupId: payload.sequenceGroupId,
						currentRideId: payload.rideId,
					});
					return;
				}
			}
		},
		[active]
	);

	return open;
}
